import type { ICouple } from '../model/ICouple'

export function isDivorced(couple: ICouple) {
	return couple.divorcedDate != null || couple.divorcedPlace != null
}
